<script>
    export let fill = "";
</script>

<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="rounded/alert/warning_amber_24px">
        <path
            id="icon/alert/warning_amber_24px"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.47012 20.5036C2.93012 20.5036 1.97012 18.8336 2.74012 17.5036L10.2701 4.49359C11.0401 3.16359 12.9601
            3.16359 13.7301 4.49359L21.2601 17.5036C22.0301 18.8336 21.0701 20.5036 19.5301 20.5036H4.47012ZM19.5301
            18.5036L12.0001 5.49359L4.47012 18.5036H19.5301ZM11.0001 10.5036V12.5036C11.0001 13.0536 11.4501 13.5036
            12.0001 13.5036C12.5501 13.5036 13.0001 13.0536 13.0001 12.5036V10.5036C13.0001 9.95359 12.5501 9.50359
            12.0001 9.50359C11.4501 9.50359 11.0001 9.95359 11.0001 10.5036ZM13.0001
            17.5036V15.5036H11.0001V17.5036H13.0001Z"
            fill="{fill}"
        ></path>
    </g>
</svg>
